// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios';
import '@/common/js/jquery.min.js';
Vue.config.devtools = true;
import VideoPlayer from 'vue-video-player'
import lottie from 'vue-lottie';
Vue.use(VideoPlayer)
Vue.component('lottie', lottie)
Vue.prototype.$axios = axios;

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import {tips} from '@/common/js/util';
Vue.prototype.$tips = tips;

import Video from 'video.js'
import 'video.js/dist/video-js.css'
import '@/common/web uyghur fonts/css.css'

import Videoplayer from 'vue-video-player'
Vue.use(Videoplayer)
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
import 'videojs-contrib-hls' //单是 RTMP 的话不需要第三方库，如果是 HLS 的话需要引入videojs-contrib-hls，看具体情况而定。


router.beforeEach((to, from, next) => {
  document.body.scrollTop = 0
  document.documentElement.scrollTop = 0
  window.pageYOffset = 0
  next()
})
Vue.prototype.$video = Video
// Vue.config.productionTip = false
// 导入时间格式化插件
import moment, { locale } from 'moment';
// 创建全局的过滤器
Vue.filter('dateFormate', function(dataStr, pattern="HH时mm分ss秒") {
  return moment(dataStr).format(pattern);
})

axios.interceptors.request.use(function (config) {
    //判断如果登录了就把token配置到axios的协议中
    let token = localStorage.getItem("TOKEN");
    if (token) {
      config.headers['token'] = token
    }
    // //处理请求前代码
    return config;
}, function (error) {
    //一些事情伴随着错误
    return Promise.reject(error)
})
axios.interceptors.response.use(function(response){
  return response
},function(err){
  return Promise.reject(err)
});
  axios.interceptors.response.use(
    response => {
      return response;
    },
    error => {
      if (error.response) {
        switch (error.response.status) {
          case 401:
            // 返回 401 清除token信息并跳转到登录页面
            localStorage.removeItem("TOKEN");
            router.replace({
              path: '/login'
          })
          localStorage.setItem("phoneflag",true)
        }
      }
      return Promise.reject(error.response.data) // 返回接口返回的错误信息
    });
  axios.post('/v1/index/logo').then(({data})=>{
    if(data.code == 200){
      router.beforeEach((to,from,next)=>{
        if (to.meta.title) {
            document.title = data.data.text_name;
            document.querySelector('meta[name="keywords"]').setAttribute('content', data.data.value)
            document.querySelector('meta[name="description"]').setAttribute('content', data.data.value)
        }
        next();
      })
    }
  })
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js